"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLibError = exports.libErrors = void 0;
/**
 * LIB ERRORS
 */
exports.libErrors = {
    1: "Extensão não instalada",
    2: "Os dados para assinar não foram fornecidos",
    3: "Certificado para assinar não foi fornecido",
    4: "O seu navegador ainda não é suportado",
    5: "O seu sistema operacional ainda não é suportado",
    6: "Links de download não fornecidos",
};
var getLibError = function (code) { return ({ level: "LIB", error: exports.libErrors[code || 1], code: code }); };
exports.getLibError = getLibError;
